module.exports = __webpack_public_path__ + "assets/img/dahuojian-d6bf88c0.png";